module.exports = __webpack_public_path__ + "img/SuccessSubmit.b4d7a1b2.png";